<div class="desktop">
    <div class="label">
        {{label}}
    </div>
    <div class="text">
        
    </div>
    <div class="value">
        <input tabindex="1" [(ngModel)]="inputValue" (blur)="emit()" placeholder="Text" matInput aria-label="field-text">
    </div>
    <div class="action">

    </div>
</div>

<div class="mobile">
    <mat-form-field appearance="outline">
        <mat-label>{{label}}</mat-label>
        <input matInput placeholder="" [(ngModel)]="inputValue" (blur)="emit()">
    </mat-form-field>
</div>